import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-room",
  "use": "icon-room-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-room\">\n    \n    <g>\n    <path d=\"M29.333 14.667v12h-2.667v-4h-21.333v4h-2.667v-21.333h2.667v13.333h10.667v-9.333h8c2.946 0 5.333 2.388 5.333 5.333v0zM10.667 17.333c-2.209 0-4-1.791-4-4s1.791-4 4-4v0c2.209 0 4 1.791 4 4s-1.791 4-4 4v0z\" />\n    </g>\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol